import React, { Component } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, getStrokeColor, kmFormatter } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class ChannelAnalysisBarChart extends Component {
    state = {};
    chartComponent = React.createRef();
    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current?.chart.setSize(null, null);
                this.chartComponent.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    formatMentionData(data) {
        let res = [];
        let total = Object.values(data)
            .map((x) => x.total)
            .reduce((x, y) => x + y, 0);
        for (let platform in data) {
            let platformName = this.props.allPlatforms.find((plt) => plt.id === platform);
            let shortName = platformName ? platformName.short_name : "";
            platformName = platformName ? platformName.name : "";
            let mentions = data[platform].total;
            let percentage = Math.round((data[platform].total / total) * 100);

            let color = getStrokeColor(shortName);
            res.push({
                name: platformName,
                percent: percentage,
                color: color,
                id: platform,
                dataLabels: {
                    inside: false,
                    x: 10,
                },
                data: [{ name: platformName, y: mentions, percent: percentage, totalVal: total, platformId: platform }],
            });
        }
        res = res && res.sort((a, b) => b.percent - a.percent);
        return res;
    }

    getOptions = () => {
        const data = this.formatMentionData(this.props.data);

        let dataX = [];
        data.map((item) => {
            dataX.push(item.name);
        });

        let self = this;
        const options = {
            chart: {
                type: "bar",
                spacingLeft: 10,
                align: "center",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: " ",
            },
            credits: {
                enabled: false,
            },
            legend: {
                enabled: this.props.showLegendBar,
                width: "20%",
                layout: "vertical",
                align: "right",
                padding: 3,
                itemMarginTop: 3,
                itemMarginBottom: 3,
                verticalAlign: "middle",
                labelFormatter: function () {
                    return `<p>${this.name}</p><br/>`;
                },
                /* eslint-disable */
            },

            xAxis: {
                // categories: dataX,
                // ordinal: true,

                type: "category",
                lineWidth: 1,
                // labels: {
                //     align: "center",
                //     //rotation: -45,
                //     y: -5,
                // },
                style: {
                    //step: 1,
                    textOverflow: "ellipsis",
                    // margin:"10px",
                },
            },

            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                labels: {
                    align: "center",
                    // rotation: -45,
                    // x: 50
                },
            },
            series: data,
            plotOptions: {
                series: {
                    pointWidth: 15,
                    stacking: "normal",
                    events: {
                        legendItemClick: function () {
                            if (this.visible) {
                                this.setData([], false);
                            } else {
                                this.setData(data[this.index].data, false);
                            }
                        },
                    },
                },
                bar: {
                    borderWidth: 0,
                    shadow: false,
                    showInLegend: true,
                    dataLabels: {
                        inside: false,
                        enabled: this.props.showLabel,
                        style: {
                            color: "#333333",
                            textOutline: "none",
                        },
                        formatter: function () {
                            return `<b>${kmFormatter(this.point.y)}</b>
                            `;
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },

            tooltip: {
                formatter: function () {
                    return `<span>${this.point.name}</span> <br/> Mentions | <b>${this.point.percent}%  | </b></span><span><b>${numberWithCommas(
                        this.point.y,
                    )}</b> / <b>${numberWithCommas(this.point.totalVal)}</b>`;
                },
                backgroundColor: "#fff",
                borderRadius: 6,
                followPointer: true,
                followTouchMove: true,
            },
        };

        return options;
    };

    render() {
        return (
            <HighchartsReact
                ref={this.chartComponent}
                highcharts={Highcharts}
                options={this.getOptions()}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default ChannelAnalysisBarChart;
